import { type AttributeFilterInput } from '@/generated'

/**
 * Update array of attribute filters based on the new list of attributes
 *
 * @param canonicalName - Name of attribute getting updated
 * @param currentAttributes - List of attributes selected before the update
 * @param newAttributeValues - List of new attribute values to be updated
 */
export const updateAttributeFilterGroup = ({
  canonicalName,
  currentAttributes,
  newAttributeValues,
}: {
  canonicalName: string
  newAttributeValues: string[]
  currentAttributes: AttributeFilterInput[]
}): AttributeFilterInput[] => {
  /** Remove attribute value from current array to be populated with the new values */
  const filteredFilters = currentAttributes.filter((item) => item.filterName !== canonicalName)

  /** If there are no values, then return list without the current attribute */
  if (!newAttributeValues.length) {
    return filteredFilters
  }

  const newValues = [...filteredFilters, { filterName: canonicalName, values: newAttributeValues }]

  /** Append back the attribute with the new values */
  return newValues
}
